import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMenuRequest } from '../redux_files/actions/menu_actions';
import OrderNowButton from '../components/order_now_button';

const langArr = [{"key": "hindi", "value": "Hindi"}, {"key": "english", "value": "English"}];

export const FoodMenu = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = React.useState("english");
  const { menu, loading } = useSelector(state => state.menu);
  const [menuArr, setMenuArr] = React.useState([]);

  useEffect(() => {
    dispatch(fetchMenuRequest(activeTab));
  }, [dispatch, activeTab]);

  useEffect(() => {
    setMenuArr(menu[activeTab]?.data || []);
  }, [menu, activeTab]);

  const renderMenuTabel = (foodItem) => {
    return foodItem.map((keyValue) => {
      for (const [day, food] of Object.entries(keyValue)) {
        return (
          <div className='row wd-100 pd-8' key={day}>
            <div className='col display-flex wd-20 text-right text-size-18'>{day}</div>
            <div className='col-2 display-flex wd-70 text-center text-size-18 ml-10'>{food}</div>
          </div>
        );
      }
    });
  };
 
  return (
    <div className='outer-border mt-10'>
      <div className='tabs'>
        {
          langArr.map((lang) => (
            <div key={lang.key} onClick={() => setActiveTab(lang.key)} className={activeTab === lang.key ? 'tab tabActive' : 'tab'}>{lang.value}</div>
          ))
        }
      </div>
      <br />
      <div className='text-center auto-margin text-bold'>
        OUR DAILY MENU
      </div>
      {loading && <div className='text-center'>Loading menu...</div>}
      {!loading && menuArr && menuArr.length > 0 && menuArr.map((menuItem) => {
        for (const [key, value] of Object.entries(menuItem)) {
          return (
            <div key={key.toString()}>
              <div className='row wd-100 text-center mb-10 mt-10 bold-font'>
                <div className='col align-to-center text-size-24'>{key}</div>
              </div>
              {renderMenuTabel(value)}
            </div>
          );
        }
      })}
      <OrderNowButton />
      <div className='text-center text-size-18 text-wrap pd-10 text-primary'><marquee>Menu would updated on monthly/quartely or seasonal basis.</marquee></div>
    </div>
  );
};
export default FoodMenu;
